import {observer} from 'mobx-react';
import React from 'react';

import {CartMessageImpressionEvent} from '@udemy/cart';
import {Tracker, TrackImpression} from '@udemy/event-tracking';
import {AlertBanner} from '@udemy/react-messaging-components';
import {safelySetInnerHTML} from '@udemy/shared-utils';

import {CartMessage as CartMessageNotice} from '../../../../hooks/use-cart-message-notice';
import styles from './styles.module.less';

export type CartMessageProps = CartMessageNotice;

export const CartMessage: React.FC<CartMessageProps> = observer(({title, subtitle}) => {
    const trackImpression = () => {
        Tracker.publishEvent(new CartMessageImpressionEvent('udlite', title, subtitle));
    };

    return (
        <TrackImpression trackFunc={trackImpression}>
            <div>
                <AlertBanner
                    className={styles['cart-message']}
                    showCta={false}
                    showIcon={false}
                    title={
                        <span
                            {...safelySetInnerHTML({
                                descriptionOfCaller: 'basic:cart-message-title',
                                html: title,
                                dataPurpose: 'cart-message-title',
                            })}
                        />
                    }
                    body={
                        <span
                            {...safelySetInnerHTML({
                                descriptionOfCaller: 'basic:cart-message-subtitle',
                                html: subtitle ?? '',
                                dataPurpose: 'cart-message-subtitle',
                            })}
                        />
                    }
                />
            </div>
        </TrackImpression>
    );
});
